import { render } from "./ColoniesFilter.vue?vue&type=template&id=a9690104&ts=true"
import script from "./ColoniesFilter.vue?vue&type=script&lang=ts"
export * from "./ColoniesFilter.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__